import React, { useEffect } from 'react';
import ModalMain from './ModalMain';
import AdjustProductPriceForm from './AdjustProductPriceForm';
import CreateNewCoupon from './CreateNewCoupon/CreateNewCoupon.Form';
import ReactivateCoupon from './ReactivateCoupon/ReactivateCoupon.Form';
import CreateBundleOffer from './CreateBundleOffer/CreateBundleOffer.Form';
import { useDispatch, useSelector } from 'react-redux';
import EndAction from './EndAction';
import { getInactiveCoupons, getInventoryProducts } from '../../../../lib/utils/apiCalls';
import { setCouponsList, setInventoryProducts } from '../../../../Features/dropTrackActionSlice';

function Modal() {
    const dispatch = useDispatch();
    const modalType = useSelector((state) => state.dropTrackProducts.modalType);

    useEffect(() => {
        const handleRequest = async () => {
            try {
                const response = await getInactiveCoupons();
                dispatch(setCouponsList(response));
            }
            catch (err) {
                console.log('Error occurred:', err);
            }
        };

        const handleProductsRequest = async () => {
            try {
                const response = await getInventoryProducts();
                dispatch(setInventoryProducts(response));
            }
            catch (err) {
                console.log('Error occurred:', err);
            }
        };
    
        handleRequest();
        handleProductsRequest();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="fixed z-50 w-full h-full top-0 left-0 bg-[#00000080] flex justify-center items-center">
            {modalType === '' && <ModalMain />}

            {modalType === 'adjust-price' && <AdjustProductPriceForm />}

            {modalType === 'create-coupon' && <CreateNewCoupon />}

            {modalType === 'create-bundle-offer' && <CreateBundleOffer />}

            {modalType === 'activate-coupon' && <ReactivateCoupon />}

            {modalType === 'end-action' && <EndAction />}
        </div>
    );
}

export default Modal;
